import React, { useState } from 'react';
import { VoiceContactForm } from '../components/features/VoiceContactForm';

export const VoiceContactDemo: React.FC = () => {
  const [contactCreated, setContactCreated] = useState(false);

  const handleContactComplete = (name: string, phone: string) => {
    console.log('Contact created:', { name, phone });
    setContactCreated(true);
    
    // Reset the success message after 3 seconds
    setTimeout(() => {
      setContactCreated(false);
    }, 3000);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-md mx-auto bg-white p-6 rounded-xl shadow-lg">
        <h1 className="text-2xl font-bold text-center mb-6">Voice Contact Input</h1>
        
        <p className="text-gray-600 mb-6 text-center">
          Speak your name and phone number or use the form to add a contact.
        </p>
        
        {contactCreated && (
          <div className="bg-green-100 text-green-700 p-4 rounded-md mb-6 text-center">
            Contact added successfully!
          </div>
        )}
        
        <VoiceContactForm onComplete={handleContactComplete} />
      </div>
    </div>
  );
};

export default VoiceContactDemo;
